import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { DomSanitizer } from '@angular/platform-browser';
import { FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router, Event, NavigationStart } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { AuthService } from './../../auth/auth.service';
import { LoginService } from './../../services/login.service';
import { EvironmentAPI } from '../../../environments/enviroments.api'

import { StateService } from '../../state.service';


interface IModelApps {
  Descriptions: string
  Name: string
  NameToLowerCase?: string
  Obs: string
  OldVersions: {
    Name: string
    ReleaseDate: Date
    ReleaseNotes: string[]
    Version: string
  }[]
  ReleaseDate: string
  ReleaseNotes: string[]
  Version: string
  icon: string
  isAndroid: boolean
  isEveryone: boolean
  isIos: boolean
  isMobile: boolean
  isTutorial: boolean
  isWeb: boolean
  link: string
  links?: {
    [x: string]: string
  }
  notification: boolean
}

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})



export class HeaderComponent implements OnInit {
  public form;
  public user = 'LOGIN';
  public tipoUsuario;
  public lang = 'PT';

  @ViewChild('userDropdown') userDropdown: ElementRef;

  @ViewChild('passwordModal') passwordModal: ElementRef;

  constructor(
    private fb: FormBuilder,
    public auth: AuthService,
    private _login: LoginService,
    private _router: Router,
    private route: ActivatedRoute,
    private cookie: CookieService,
    private _toastr: ToastrService,
    private _modal: NgbModal,
    private stateService: StateService,
    private sanitizer: DomSanitizer
  ) {
    this.form = fb.group({
      username: ['', Validators.required],
      password: ['', Validators.required]
    });
    setInterval( () => {
      this.portal = JSON.parse(this.cookie.get('portal') || '{}');
      if (this.portal.User) { // se o usuário está logado
        this.sistemas = this.portal.User.Sistemas;

        if( (/^(funcionario|admvendas|gestor)$/i).test(this.portal.User.Tipo) ){
          this.sistemas.push('cec-helpdesk');
          this.sistemas.push('monday');
          this.sistemas.push('AdmLogin');
          this.sistemas.push('')
        };

        if( (/^(funcionario)$/i).test(this.portal.User.Tipo) ){
          this.sistemas.push('gestao-de-campanhas');
        };

      };
    }, 100);
    this.isAppStorePage = this.checkIfIsAppStorePage(undefined);
    this.ifResetVisualized();
    this._router.events.subscribe((event: Event) => {
      if (event instanceof NavigationStart) {
        this.isAppStorePage = this.checkIfIsAppStorePage(event.url.substring(1,10));
        this.ifResetVisualized();
      };
    });
  }

  isAppStorePage = false;
  visualized = false;

  ifResetVisualized(){
    // se estiver em qualquer uma rota, apenas ignore
    if( !this.isAppStorePage && !this.visualized ){
      return false;
    };
    // se estiver em appstore marca como visualizado
    if(this.isAppStorePage && !this.visualized){
      return this.visualized = true;
    };
    // se já tiver visualizado e estiver em outra rota, então reseta a notificação e o visualizado
    if(!this.isAppStorePage && this.visualized){
      // reset
      this.visualized = false;
      this.removeNotifications();
      // remove notificações em appstore
      this.appstore.map((app_)=>{
        app_.notification = false;
        return app_;
      });
    };
  };

  checkIfIsAppStorePage(url:any){
    if(url === undefined){
      url = window.location.href;
      url = url.replace('//', '').replace('/#/', '/');
      url = url.substring( url.indexOf('/') + 1, );
      return url.substring(0,9) === 'appstore';
    };
    return url === 'appstore';
  }

  isProd = window.location.href.indexOf('focustextil.com.br/site/') > -1;

  // routeProd = 'https://webrep2.focustextil.com.br/api/v2/versions';
  // routeQa = 'http://vivo-dev-node.focustextil.loc.br:1037/api/v2/versions';
  

  routeVersions = EvironmentAPI.api

  portal: any;
  sistemas = [];
  appstore: IModelApps[];
  appsOld: any;
  appsNew: any;
  showNotification = false;

  ngOnInit() {
    let self: any = this;
    let portal: any = this.cookie.get('portal');
    if(portal !== ''){
      try{
          portal = JSON.parse(portal);
      }catch(error){
        portal = { User: {FullName: 'LOGIN', Tipo: 'Nenhum', Sistemas: ['']} };
      };
    }else{
      portal = { User: {FullName: 'LOGIN', Tipo: 'Nenhum', Sistemas: ['']} };
    };

    self.user = portal.User.FullName;
    self._login.ifPedidos_( portal ); // if cliente then redirect

    this._login.setUser(portal);

    this._login.usuario.subscribe(usuario => this.user = usuario);
    this._login.usuario = portal.User.FullName;

    this._login.tipoUsuario.subscribe(tipoUsuario => this.tipoUsuario = tipoUsuario);
    this._login.tipoUsuario = portal.User.Tipo;

    this.getApps();
  }

  getApps(){
    // if( !this.checkIfIsAppStorePage(undefined) || ( this.checkIfIsAppStorePage(undefined) && this.appstore.length === 0 ) ){
      fetch(this.routeVersions, {
        method: 'POST'
      }).then((appstore) => {
        return appstore.json();
      }).then((appstore: IModelApps[]) => {
        this.appstore = appstore;
        this.appstore = this.sortApps(this.appstore);
        this.appstore = this.addInfos(this.appstore);
        this.appsNew = [];
  
        // compacta o app para jogar no localStorage
        appstore.forEach((app) => {
          this.appsNew.push({
            name: app.Name.toLowerCase(),
            version: app.Version.replace('v', '')
          });
        });
  
        this.appsOld = localStorage.getItem('appstore-notifications');
  
        if( !this.appsOld ){
          // se não houver valor guardado
          // então todos os apps são novos e as notificações devem ficar true
          this.appsNew.map((appNew)=>{
            appNew.notification = true;
            return appNew;
          });
          if(!this.checkIfIsAppStorePage(undefined)){
            this.showNotification = true;
          };
          localStorage.setItem('appstore-notifications', JSON.stringify(this.appsNew));
          this.stateService.setGlobal('appstore-notifications', this.appsNew);
          this.appsOld = this.JSONClone(this.appsNew);
        }else{
          this.appsOld = JSON.parse(this.appsOld);
          this.stateService.setGlobal('appstore-notifications', this.appsNew);
        };
  
        // compara se houve alterações entre a versão local e a versão nova (appsNew)
        this.appsNew.map((appNew)=>{
          let appOld = this.appsOld.find((appOld)=>{
            return appOld.name === appNew.name;
          });
          if(appOld){
            if(appOld.version !== appNew.version || appOld.notification){
              appNew.notification = true;
              if(!this.checkIfIsAppStorePage(undefined)){
                this.showNotification = true;
              };
            };
          };
          return appNew;
        });
  
        // joga as notificações para o appstore (para inserir no DOM em /appstore)
        this.appstore.map((app_)=>{
          let appNew = this.appsNew.find((appNew)=>{
            return appNew.name === app_.NameToLowerCase;
          });
          if(appNew){
            app_.notification = appNew.notification;
          };
          return app_;
        }, 100);
        this.stateService.setGlobal('appstore', this.appstore);
      });

    // };

    setTimeout(()=>{
      this.getApps();
    }, 15000);
  }

  removeNotifications(){
    // zera o showNotification, remove os app.notifications e salva no localStorage
    this.showNotification = false;
    this.appsNew.map((appNew)=>{
      appNew.notification = false;
      return appNew;
    });
    localStorage.setItem('appstore-notifications', JSON.stringify(this.appsNew));
  }

  sortApps (apps) {
    let appOrder = ['webrep', 'webfair', 'ifair', 'ebook', 'gestao-de-campanhas', 'efocus', 'danfexml', 'admlogin', 'ForaDeAcesso', 'cec-helpdesk', 'focus-summit', 'monday'];
    console.log('apps', apps)
    apps.forEach((app, index) => {
      if(app.Name === 'CEC – Helpdesk'){
        app.Name = 'cec-helpdesk';
      };
      // name to lower case
      apps[index].NameToLowerCase = apps[index].Name.toLowerCase();
    });
    apps.sort((a, b) => {
      a = appOrder.indexOf(a.NameToLowerCase);
      b = appOrder.indexOf(b.NameToLowerCase);
      a = a === -1 ? 99 : a;
      b = b === -1 ? 99 : b;
      return a > b ? 1 : a === b ? 0 : -1;
    });

    return apps;
  }

  addInfos (apps: IModelApps[]) {
    let appsAndroid = ['ifair'];
    let appsIos = ['ifair'];
    let appsMobile = ['ifair']
    let appsWeb = ['danfexml', 'ebook', 'gestao-de-campanhas', 'efocus', 'webfair', 'webrep', 'cec-helpdesk', 'focus-summit','admlogin', 'monday', 'foracesso'];
    let appEveryonePage = ['focus-summit']
    let appsTutorial = ['ifair']
    let appCheck = [];

    apps.forEach((app) => {
      appCheck.push({
        name: app.NameToLowerCase,
        version: app.Version
      });
    });

    apps.map((app) => {
      app.ReleaseDate = app.ReleaseDate.substring(0, app.ReleaseDate.indexOf(' '));
      app.links = { web: app.link }
      app.isAndroid = appsAndroid.indexOf(app.NameToLowerCase) > -1;
      app.isMobile = appsMobile.indexOf(app.NameToLowerCase) > -1;
      app.isIos = appsIos.indexOf(app.NameToLowerCase) > -1;
      app.isWeb = appsWeb.indexOf(app.NameToLowerCase) > -1;
      app.isTutorial = appsTutorial.indexOf(app.NameToLowerCase) > -1;
      app.isEveryone = appEveryonePage.indexOf(app.NameToLowerCase) > -1;
    });
    
    return apps;
  }

  getURL (site: string) {
    const url =  EvironmentAPI[site]
    return this.sanitizer.bypassSecurityTrustUrl(url)
  }

  login() {
    if (this.form.valid) {
      this._login.login(
        this.form.value.username.trim(),
        this.form.value.password,
        this._login.login2,
      );
    } else {
      this._toastr.error('Preencha o login e senha para acessar!');
    };
  }

  logout(): void {
    let hostname = window.location.hostname;
    if(hostname.startsWith('.')) {
      hostname = hostname.substring(1);
    }
    this.cookie.set('portal', '', 14, '/', hostname, EvironmentAPI.isPRD, 'Lax');
    this.cookie.delete('portal');
    localStorage.clear();
    this.user = 'LOGIN';
    this.tipoUsuario = '';
    this.userDropdown.nativeElement.click();
    this._router.navigate(['/site']);
    window.scroll({ top: 0, left: 0 });
  }

  openModal() {
    this._modal.open(this.passwordModal, { windowClass: 'password-modal', backdrop: 'static', keyboard: false, centered: true});
  }

  forgotPassword() {
    let data:any = {
      User: this.form.value.username.toUpperCase()
    };
    let request = new XMLHttpRequest();
    request.open('POST', 'https://webrep2.focustextil.com.br/api/v1/ForgotPassword', true);
    request.setRequestHeader('Access-Control-Allow-Origin', '*');
    request.setRequestHeader('Content-Type', 'application/json; charset=utf-8');
    request.send( JSON.stringify(data) );
    request.onreadystatechange = function() {
      if (this.readyState === 4) {
        if (this.status >= 200 && this.status < 400) {
          // Success!
          let resp:any = this.responseText;
          if(resp[0] == '{' && resp[resp.length - 1] == '}'){
            resp = JSON.parse(resp);
          };

          // "criptografa" o email
          let email = resp.Results.toLowerCase().replace('email enviado para:', '');

          let emailName = email.match(/(.+?)@/)[1];
          emailName = emailName.substring(0, 3) + emailName.replace(/./g, '*').substring(3);
          emailName = emailName + '@';

          let emailDomain = email.match(/@(.+?\.)/)[1];
          emailDomain = emailDomain.substring(0, 2) + emailDomain.replace(/[^\.]/g, '*').substring(2);

          let emailAbbr = email.match(/@.+?\.(.+)/)[1];
          emailAbbr = emailAbbr.replace(/[^\.]/g, '*');

          email = emailName + emailDomain + emailAbbr;
          // /"criptografa" o email
          window['Swal'].fire(
            'Sucesso:',
            'E-mail enviado para: ' + email,
            'success'
          );
        } else {
          // Error :(
          let resp:any = this.responseText;
          if(resp[0] == '{' && resp[resp.length - 1] == '}'){
            resp = JSON.parse(resp);
          };
          if(typeof resp.Error !== 'string'){
            // objToString(obj:any) {
              let return_ = [];
              let keys = Object.keys(resp.Error);
              let values = Object.values(resp.Error);
              for (let i = 0; i < keys.length; i++) {
                return_.push(keys[i] + ': ' + values[i].toString() + (!!values[i].toString().match(/\./) ? '' : '.'));
              };
              return_.join(' ');
              resp.Error = return_;
            // };
          };
          window['Swal'].fire(
            'Erro:',
            'Houve um problema. ' + resp.Error,
            'error'
          );
        };
      };
    };
  }

  gotoShowroom() {
    let showroom:any = document.querySelector('#showroom');
    if (showroom != null) {
      window.scroll({ top: showroom.offsetTop + 0, left: 0, behavior: 'smooth' });
    } else {
      this._router.navigate(['/site'], { fragment: 'showroom' });
    };
  }

  JSONClone(json:object){
    return JSON.parse(JSON.stringify(json));
  }
}